import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

function AboutModal({startChat, setOpenAbout}) {
    return(
        <div className={`about-modal-wrapper ${startChat ? "in-chat" : ""}`}>
            <div className="modal-wrapper">
                <div className="m-header">
                    <span>About ePa</span>
                    <CloseIcon onClick={()=> setOpenAbout(false)} />
                </div>
                <div className="m-body">
                    <h4>'epa' Virtual Assistant</h4>
                    <p>ePA is available to support you 24x7 for any question related to eSoft Development & Technologies.</p>
                </div>
            </div>
        </div>
    )
}
export default AboutModal;
